import React from 'react';
import { PDFDownloadLink, Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import logo from "Assets/images/logo.png";
import { globalStyles } from "config/pdfStyles";
import { ClientDetailsPdf } from "./Components/ClientDetails";
import { REPORT_QUESTIONS } from "config/constants";
import RenderAnswer, { RenderAnswerByQId } from "./Components/AnswerFields/Index";
import TherapistSignaturePdf from "./Components/TherapistSignature";
import KhanReportLogoPdf from "./Components/KhanReportLogoPdf";
import GoalReviewSection from "./Components/GoalReviewSection";
import ReportFooter from "./Components/ReportFooter";

// Create styles
const styles = StyleSheet.create({
  header: {
    alignItems: "center",
    justifyContent: "center"
  },
  logo: {
    width: "20%",
  },
  templateHeading: {
    fontSize: "15px",
    marginBottom: "10px",
  },
  templateContainer: {
    flexDirection: "column",
  },
  templateField: {
    paddingVertical: "10px",
  },
  questionHeading: {
    ...globalStyles.fontBold,
    fontSize: "12px",
    marginBottom: "5px",
  }
});

export const AssessmentTreatmentPlanPdfDoc = ({ data }) => {
  const reportHeading = data?.assesment?.report_heading;
  const reportQuestions = data?.assesmentData?.reportQuestions;
  const reportAnswers = data?.assesmentData?.reportAnswers;
  const assessmentGoals = data?.assesmentData?.reportGoals;

  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const caseTherapist = data?.clientPendingCaseload?.clientCaseloadTherapist?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type == "veteran")?.caseTherapist;
  const therapistDetails = { caseDiscipline, caseTherapist }

  return (
    <Document>
      <Page size="A4" style={globalStyles.page}>

        {/* Report Header */}
        <View style={[globalStyles.section, styles.header]}>
          <Image
            style={styles.logo}
            src={logo}
          />
          <Text style={globalStyles.reportHeading}>{reportHeading}</Text>
        </View>
        <View style={globalStyles.section}>
          <ClientDetailsPdf
            data={data}
          />
        </View>

        {/* Questions & Answers */}
        <View style={globalStyles.section}>
          {reportQuestions?.length > 0 &&
            reportQuestions?.map((question, index) => {
              let foundAnswer = reportAnswers?.length && reportAnswers.find(answer => answer.question_id === question.id);
              if (
                [
                  REPORT_QUESTIONS.greeting,
                  REPORT_QUESTIONS.summary,
                  REPORT_QUESTIONS.recommendation,
                ].includes(question.id)
              ) {
                return null;
              }

              return (
                <RenderAnswer
                  key={index}
                  question={question}
                  answer={foundAnswer}
                />
              );
            })
          }
        </View>

        {/* Goal Details */}
        <View style={globalStyles.section}>
          
          <GoalReviewSection
            assessmentGoals={assessmentGoals}
            therapistDetails={therapistDetails}
          />

          <RenderAnswerByQId
            questionId={REPORT_QUESTIONS.summary}
            reportQuestions={reportQuestions}
            reportAnswers={reportAnswers}
          />

          <RenderAnswerByQId
            questionId={REPORT_QUESTIONS.recommendation}
            reportQuestions={reportQuestions}
            reportAnswers={reportAnswers}
          />

          <RenderAnswerByQId
            questionId={REPORT_QUESTIONS.greeting}
            reportQuestions={reportQuestions}
            reportAnswers={reportAnswers}
            showQuestion={false}
          />

          {/* Therapist Signature */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <TherapistSignaturePdf
              therapistDetails={therapistDetails}
            />
          </View>

          {/* Branding */}
          <View style={globalStyles.reportQuestionOuter} wrap={false}>
            <KhanReportLogoPdf />
          </View>
        </View>

        <ReportFooter
          data={data}
        />
      </Page>
    </Document>
  )
};
